var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:[
    'v-searchable-select',
    'v-searchable-select-shallow',
    _vm.small && 'v-searchable-select--small',
    _vm.gray && 'v-searchable-select--gray',
    _vm.search && 'v-searchable-select--search',
    _vm.disabled && 'v-searchable-select-shallow--disabled'
  ]},_vm.$listeners),[(!_vm.async)?_c('div',{staticClass:"multiselect__caret"},[_c('v-icon',{attrs:{"name":"caret","width":"12"}})],1):_vm._e(),(_vm.search)?_c('div',{staticClass:"multiselect__search-icon"},[_c('v-icon',{attrs:{"name":"search","width":"22"}})],1):_vm._e(),_c('div',{staticClass:"multiselect__tags"},[_c('span',{staticClass:"multiselect__placeholder"},[_vm._v(_vm._s(_vm.getPlaceholderValue()))])]),_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.getInputValue()}})])}
var staticRenderFns = []

export { render, staticRenderFns }